export const masterMessageTabTypes = {
  templates: "Chat",
  bots: "BOT",
};
